<template>
  <div>
    <div class="filter-container">
      <el-row :gutter="10">
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.report_number" placeholder="请输入检测报告编号" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.equipment_name" placeholder="请输入设备名称" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <div>
            <el-input v-model="listQuery.client" placeholder="请输入委托单位" clearable class="filter-item" @keyup.enter.native="handleFilter" />
          </div>
        </el-col>
        <el-col :md="4" :sm="6">
          <el-select v-model="listQuery.inspection_result" clearable placeholder="请选择检测结论">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-col>
        <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
          搜索
        </el-button>
        <el-button v-if="checkPermission(['larke-admin.verification.create'])" v-waves class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate">
          新建
        </el-button>
      </el-row>
    </div>

    <el-table
      ref="securityTable"
      v-loading="loading"
      :data="list"
      border
      style="width: 100%"
      element-loading-text="拼命加载中..."
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="report_number" label="报告编号" />
      <el-table-column prop="equipment_name" label="设备名称" />
      <el-table-column prop="equipment_model" label="设备型号" />
      <el-table-column prop="client" label="委托单位" />
      <el-table-column prop="equipment_number" label="设备号牌" />
      <el-table-column label="检测结论">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.inspection_result" type="info">未检测</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '合格'" type="success">{{ scope.row.inspection_result }}</el-tag>
          <el-tag v-else-if="scope.row.inspection_result === '不合格'" type="danger">{{ scope.row.inspection_result }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="inspection_date" label="检测日期" />
      <el-table-column label="当前状态">
        <template slot-scope="scope">
          <el-tag v-if="!scope.row.stage" type="success" effect="dark">待检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 1" type="success">已检测</el-tag>
          <el-tag v-else-if="scope.row.stage === 2" type="warning" effect="dark">待审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 3" type="warning">已审核</el-tag>
          <el-tag v-else-if="scope.row.stage === 4" effect="dark">待批准</el-tag>
          <el-tag v-else-if="scope.row.stage === 5">已批准</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" />
      <el-table-column align="left" label="操作" width="320">
        <template slot-scope="scope">
          <el-button
            v-if="checkPermission(['larke-admin.verification.update']) && (scope.row.stage === 0 || scope.row.stage === 1)"
            v-waves
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="checkPermission(['larke-admin.verification.delete'])"
            v-waves
            size="mini"
            type="danger"
            @click="handleDelete(scope.row)"
          >
            删除
          </el-button>
          <el-button
            v-if="checkPermission(['larke-admin.verification.check'])"
            v-waves
            size="mini"
            type="info"
            @click="handleReview(scope.row)"
          >
            审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="handleTable"
    />

    <!--  创建安全检验报告  -->
    <el-dialog
      title="创建安全检验报告"
      :visible.sync="create.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1300px"
    >
      <create-security :item="create" @success="handleCreateSuccess" />
    </el-dialog>

    <!--  编辑安全检验报告  -->
    <el-dialog
      title="编辑安全检验报告"
      :visible.sync="edit.dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1300px"
    >
      <edit-security :key="edit.id" :item="edit" @success="handleEditSuccess" />
    </el-dialog>

    <!--  预览安全检验报告  -->
    <el-dialog
      title="预览安全检验报告"
      :visible.sync="preview.dialogVisible"
      width="70%"
    >
      <preview-security :item="preview" />
    </el-dialog>

    <!--  审核安全检验报告  -->
    <el-dialog
      title="审核安全检验报告"
      :visible.sync="review.dialogVisible"
      width="70%"
    >
      <preview-security :item="review" @success="handleReviewSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import waves from '@/directive/waves'
import checkPermission from '@/utils/permission'
import permission from '@/directive/permission'
import { list, remove, review } from '@/api/security'
import Pagination from '@/components/Pagination'
import CreateSecurity from '@/views/verification/Components/CreateSecurity.vue'
import EditSecurity from '@/views/verification/Components/EditSecurity.vue'
import PreviewSecurity from '@/views/verification/Components/PreviewSecurity.vue'

export default {
  name: 'Security',
  components: { CreateSecurity, EditSecurity, PreviewSecurity, Pagination },
  directives: { waves, permission },
  data() {
    return {
      loading: false,
      create: {
        dialogVisible: false
      },
      edit: {
        dialogVisible: false,
        id: 0,
        data: {}
      },
      preview: {
        dialogVisible: false,
        id: 0,
        data: {}
      },
      review: {
        dialogVisible: false,
        id: 0,
        data: {}
      },
      total: 0,
      list: [],
      options: [
        { label: '合格', value: '合格' },
        { label: '不合格', value: '不合格' }
      ],
      listQuery: {
        page: 1,
        limit: 20,
        report_number: '',
        equipment_name: '',
        client: '',
        inspection_result: '',
        stage: [0]
      }
    }
  },
  created() {
    this.handleTable()
  },
  methods: {
    checkPermission,
    handleTable() {
      this.loading = true
      list(this.listQuery).then(response => {
        if (response && response.data) {
          this.list = response.data.data || []
          this.total = response.data.total || 0
        }
        this.loading = false
      }).catch((error) => {
        console.error('获取安全检验报告列表失败:', error)
        this.loading = false
        this.list = []
        this.total = 0
        this.$message.error('获取数据失败，请刷新重试')
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.handleTable()
    },
    handleCreate() {
      this.create.dialogVisible = true
    },
    handleCreateSuccess() {
      this.create.dialogVisible = false
      this.handleTable()
      this.$message.success('创建成功')
    },
    handleEdit(row) {
      this.edit.id = row.id
      this.edit.data = row
      this.edit.dialogVisible = true
    },
    handleEditSuccess() {
      this.edit.dialogVisible = false
      this.handleTable()
      this.$message.success('更新成功')
    },
    handleDetail(row) {
      this.preview.id = row.id
      this.preview.data = row
      this.preview.dialogVisible = true
    },
    handleReview(row) {
      this.review.id = row.id
      this.review.data = row
      this.review.dialogVisible = true
    },
    handleReviewSuccess(params) {
      review(params).then(() => {
        this.review.dialogVisible = false
        this.handleTable()
        this.$message.success('审核成功')
      }).catch(() => {
        this.$message.error('审核失败')
      })
    },
    handleDelete(row) {
      this.$confirm('此操作将永久删除该报告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        remove(row.id).then(() => {
          this.handleTable()
          this.$message.success('删除成功')
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    }
  }
}
</script>

<style scoped>

</style>
